import React, {
  Fragment,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useKyc } from "../../hooks/useKyc";
import FContainer from "../../components/FContainer/FContainer";
import { postAbort } from "../../api/kyc";

const MenuKycScreen = ({ param }) => {
  const { SetDocumentProcess } = useContext(AuthContext);

  const route = useNavigate();

  let token = localStorage.getItem("token");
  const tokenDecode = jwt_decode(token);

  const { refreshToken } = useKyc();


  // const [selectedOption, setSelectedOption] = useState(null);

  // const handleChange = (e) => {
  //   setSelectedOption(e);
  //   //console.log(selectedOption);
  // };
  const openWhatsappKYC = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=+17547045658&text=Hola 👋🏻, quiero activar mi *FIADO* (presiona el botón enviar ➡️)",
      "_blank"
    );
    //window.open('https://api.whatsapp.com/send?phone=+17547045658&text=FiadoDemo1','_blank');
  };

  const matiButtonUSA = useRef(null);
  const openMetamapKYCUSA = () => {
    matiButtonUSA.current.click();
    addMatiListener(matiButtonUSA.current);
  };

  const matiButtonMX = useRef(null);
  const openMetamapKYCMX = () => {
    matiButtonMX.current.click();
    addMatiListener(matiButtonMX.current);
  };


  const addMatiListener = (ref) => {
    ref.addEventListener("mati:exitedSdk", async ({ detail }) => { 
      route("/");
      await postAbort({provider:"METAMAP", verificationId:detail.verificationId})
      await refreshToken();
    });

    ref.addEventListener("mati:userFinishedSdk", async ({ detail }) => {
      route("/");
      await refreshToken();
    });
  };

  
  return (
    <>
      <FContainer>
        <div>
          <div className="font-bold text-center p-5 text-xl">
            ¿De qué país son tus documentos?
          </div>
          <div
            className="flex justify-center p-2 cursor-pointer"
            onClick={() => {
              // SetDocumentProcess(true);
              // openWhatsappKYC();
              openMetamapKYCMX();
            }}
          >
            <div className="p-3 flex  bg-slate-200 rounded-xl w-full">
              <div className="w-full">
                <div className="flex bg-stripes-sky text-center justify-center">
                  <img
                    className="w-[120px]"
                    src={require("../../components/assets/images/mexico.png")}
                    alt=""
                  />
                </div>
                <div className="flex bg-stripes-sky text-center justify-center font-semibold">
                  México
                </div>
              </div>
            </div>
          </div>

          <div
            className="flex justify-center p-2 cursor-pointer"
            onClick={() => {
              openMetamapKYCUSA();
            }}>
            <div className="p-3 flex  bg-slate-200 rounded-xl w-full">
              <div className="w-full">
                <div className="flex bg-stripes-sky text-center justify-center">
                  <img
                    className="w-[120px]"
                    src={require("../../components/assets/images/estados-unidos.png")}
                    alt=""
                  />
                </div>
                <div className="flex bg-stripes-sky text-center justify-center font-semibold">
                  EE.UU
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="invisible">
          <mati-button
            ref={matiButtonUSA}
            id="mati-button"
            clientid={"6165cc44564076001bea0517"}
            flowId={"632abc7edbe73b001cbce858"}
            metadata={`{"countryId":"840", "directoryId": "${JSON.parse(localStorage.getItem("tokenDecoded")).directoryId
              }","typeOfDirectoryId": "${JSON.parse(localStorage.getItem("tokenDecoded")).typeOfDirectoryId
              }"}`} />
        </div>
        <div className="invisible">
          <mati-button
            ref={matiButtonMX}
            id="mati-button"
            clientid={"6165cc44564076001bea0517"}
            flowId={"632b60ca6d082d001c9c57d4"}
            metadata={`{"countryId":"484", "directoryId": "${JSON.parse(localStorage.getItem("tokenDecoded")).directoryId
              }","typeOfDirectoryId": "${JSON.parse(localStorage.getItem("tokenDecoded")).typeOfDirectoryId
              }"}`}
          />
        </div>
      </FContainer>
    </>
  );
};

export default MenuKycScreen;
